import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Button, Card, CardContent, Stack, CardMedia } from '@mui/material';
import { Icon } from '@iconify/react';
import { Link as RouterLink } from 'react-router-dom';
import { get } from 'lodash';
import Page from '../../components/Page';
import config from '../../util/config';
import { achivements, reviews, contactInfo } from './informationHomePage';
import { getAllCourses } from 'src/axiosLib/services/course/user';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sliderSettings = {
  dots: true, infinite: true, speed: 500, autoplay: true, autoplaySpeed: 3000,
  slidesToShow: 3, slidesToScroll: 1,
  responsive: [
    { breakpoint: 900, settings: { slidesToShow: 2 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ],
};

const SectionTitle = ({ children, light }) => (
  <Box sx={{ textAlign: 'center', mb: 5 }}>
    <Typography variant="h3" sx={{
      fontWeight: 800, color: light ? '#fff' : '#0c366d',
      textTransform: 'uppercase', letterSpacing: 2,
    }}>{children}</Typography>
    <Box sx={{
      width: 80, height: 4, mx: 'auto', mt: 2, borderRadius: 2,
      background: 'linear-gradient(90deg, #00d4ff, #7b2ff7)',
    }} />
  </Box>
);

export default function CoolHomePage() {
  const [courses, setCourses] = useState([]);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    getAllCourses({}, (err, data) => { if (!err) setCourses(data); });
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Page title="Medi Inn - Home">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap');
        .cool-home * { font-family: 'Inter', sans-serif; }
        .cool-home .slick-dots li button:before { color: #7b2ff7; font-size: 10px; }
        .cool-home .slick-dots li.slick-active button:before { color: #00d4ff; }
        @keyframes float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-15px); } }
        @keyframes fadeInUp { from { opacity:0; transform:translateY(40px); } to { opacity:1; transform:translateY(0); } }
        @keyframes pulse { 0%,100% { box-shadow: 0 0 0 0 rgba(0,212,255,0.4); } 70% { box-shadow: 0 0 0 20px rgba(0,212,255,0); } }
        .hero-float { animation: float 4s ease-in-out infinite; }
        .fade-in { animation: fadeInUp 0.8s ease-out both; }
        .pulse-btn { animation: pulse 2s infinite; }
        .glass-card {
          background: rgba(255,255,255,0.08); backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,0.15); border-radius: 20px;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .glass-card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.3); }
        .course-card {
          border-radius: 16px; overflow: hidden; transition: transform 0.3s, box-shadow 0.3s;
          border: none; background: #fff;
        }
        .course-card:hover { transform: translateY(-6px); box-shadow: 0 16px 32px rgba(0,0,0,0.12); }
        .review-card {
          border-radius: 16px; overflow: hidden; transition: transform 0.3s;
          background: linear-gradient(135deg, #f8f9ff 0%, #e8ecff 100%);
          border: 1px solid rgba(123,47,247,0.1); padding: 24px; margin: 8px;
        }
        .review-card:hover { transform: scale(1.03); }
        .contact-item {
          display: flex; align-items: center; gap: 16px; padding: 16px 24px;
          border-radius: 12px; cursor: pointer; transition: all 0.3s;
          background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);
        }
        .contact-item:hover { background: rgba(255,255,255,0.12); transform: translateX(8px); }
      `}</style>

      <Box className="cool-home">
        {/* HERO with biology cover background */}
        <Box sx={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden',
          background: 'linear-gradient(135deg, #0a0e27 0%, #1a1a3e 40%, #0c366d 100%)',
        }}>

          <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems="center">
              <Box sx={{ flex: 1 }} className="fade-in">
                <Typography sx={{
                  fontSize: { xs: '0.9rem', md: '1rem' }, color: '#00d4ff', fontWeight: 700,
                  letterSpacing: 3, textTransform: 'uppercase', mb: 2,
                }}>
                  সাদা এ্যাপ্রোনের স্বপ্ন পূরণে
                </Typography>
                <Typography sx={{
                  fontSize: { xs: '2rem', md: '3.2rem' }, fontWeight: 900, color: '#fff',
                  lineHeight: 1.2, mb: 2,
                }}>
                  ডাঃ আসিফ ও<br />
                  <Box component="span" sx={{
                    background: 'linear-gradient(90deg, #00d4ff, #7b2ff7)',
                    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                  }}>K@bir Sizer</Box>
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '1.05rem', lineHeight: 1.8, mb: 4, maxWidth: 520 }}>
                  <strong>Medi Inn</strong> পরিবারের সাথে শুরু হোক তোমার পথচলা। Online Medical Admission Test প্রিপারেশনে দেশ সেরা শিক্ষক ডাঃ আসিফ ও K@bir Sizer স্যারের দেশ সেরা প্লাটফর্ম <strong>Medi Inn</strong>।সপ্তাহে ৬ দিন লাইভ ক্লাস ও নিজস্ব ওয়েবসাইটে সম্পূর্ন মেডিকেল স্ট্যান্ডার্ড প্রশ্নপত্রে পরীক্ষা নেওয়া হয়।৩ দিন Physics, Chemistry &amp; Biology এর পাশাপাশি বাকী ৩ দিন English &amp; General Knowledge এর উপর ক্লাস নেওয়া হয়।মেডিকেল এ্যাডমিশনের প্রতিটি ক্লাস ডাঃ আসিফ এবং K@bir Sizer ভাইয়া নিয়ে থাকে।মেডিকেল এ্যাডমিশনে ১০০% প্রিপারেশনে <strong>Medi Inn</strong> এর স্টুডেন্ট অন্যান্যদের তুলনায় সর্বদা একধাপ এগিয়ে থাকে আলহামদুলিল্লাহ।
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Button variant="contained" size="large" component={RouterLink} to="/login" className="pulse-btn"
                    sx={{
                      background: 'linear-gradient(45deg, #00d4ff, #7b2ff7)', fontWeight: 700,
                      px: 4, py: 1.5, borderRadius: 3, fontSize: '1rem', textTransform: 'none',
                    }}>
                    Login / Dashboard
                  </Button>
                  <Button variant="outlined" size="large" component="a" href="#courses"
                    sx={{
                      borderColor: 'rgba(255,255,255,0.3)', color: '#fff', fontWeight: 600,
                      px: 4, py: 1.5, borderRadius: 3, fontSize: '1rem', textTransform: 'none',
                      '&:hover': { borderColor: '#00d4ff', background: 'rgba(0,212,255,0.1)' },
                    }}>
                    কোর্স দেখুন
                  </Button>
                </Stack>
              </Box>
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }} className="hero-float">
                <Box component="img" src={config.BASE_API_URL + '/public/img/asif/hero.avif'}
                  sx={{ maxWidth: { xs: 280, md: 420 }, borderRadius: 4, boxShadow: '0 30px 60px rgba(0,0,0,0.4)' }} />
              </Box>
            </Stack>
          </Container>
        </Box>

        {/* STATS BAR */}
        <Box sx={{ background: 'linear-gradient(90deg, #7b2ff7, #00d4ff)', py: 4 }}>
          <Container>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="space-around" alignItems="center">
              {[
                { num: '১০০০+', label: 'শিক্ষার্থী' },
                { num: '৯৫%', label: 'সাফল্যের হার' },
                { num: '৬ দিন', label: 'সাপ্তাহিক ক্লাস' },
                { num: '৫+', label: 'বছরের অভিজ্ঞতা' },
              ].map((s, i) => (
                <Box key={i} sx={{ textAlign: 'center' }}>
                  <Typography sx={{ fontSize: '2.2rem', fontWeight: 900, color: '#fff' }}>{s.num}</Typography>
                  <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>{s.label}</Typography>
                </Box>
              ))}
            </Stack>
          </Container>
        </Box>

        {/* COURSES */}
        <Box id="courses" sx={{ py: 10, background: '#f8f9ff' }}>
          <Container>
            <SectionTitle>আমাদের কোর্স সমূহ</SectionTitle>
            <Box sx={{ px: 2 }}>
              <Slider {...sliderSettings} slidesToShow={Math.min(courses.length || 1, 3)}>
                {courses.map((course, i) => (
                  <Box key={i} sx={{ px: 1.5 }}>
                    <Card className="course-card" elevation={0}>
                      <CardMedia component="img" height="200" image={config.BASE_API_URL + get(course, 'image')} />
                      <CardContent sx={{ p: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0c366d', mb: 1 }}>
                          {get(course, 'title')}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, minHeight: 40 }}>
                          {get(course, 'description', '').substring(0, 80)}...
                        </Typography>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography sx={{ fontWeight: 800, color: '#7b2ff7', fontSize: '1.1rem' }}>
                            {get(course, 'discountedPrice') ? (
                              <><del style={{ color: '#999' }}>৳{get(course, 'price')}</del> ৳{get(course, 'discountedPrice')}</>
                            ) : <>৳{get(course, 'price')}</>}
                          </Typography>
                          <Button size="small"
                            onClick={() => window.location.href = '/coolCourse?courseId=' + get(course, '_id')}
                            sx={{
                            background: 'linear-gradient(45deg, #00d4ff, #7b2ff7)', color: '#fff',
                            fontWeight: 700, borderRadius: 2, px: 2, textTransform: 'none',
                          }}>Register</Button>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Box>
                ))}
              </Slider>
            </Box>
          </Container>
        </Box>

        {/* ACHIEVEMENTS */}
        <Box sx={{ py: 10, background: 'linear-gradient(135deg, #0a0e27 0%, #1a1a3e 100%)' }}>
          <Container>
            <SectionTitle light>আমাদের অর্জন</SectionTitle>
            <Slider {...sliderSettings} slidesToShow={Math.min(achivements.length, 3)}>
              {achivements.map((img, i) => (
                <Box key={i} sx={{ px: 1.5 }}>
                  <Box component="img" src={config.BASE_API_URL + img}
                    sx={{ width: '100%', borderRadius: 3, boxShadow: '0 8px 30px rgba(0,0,0,0.4)' }} />
                </Box>
              ))}
            </Slider>
          </Container>
        </Box>

        {/* REVIEWS */}
        <Box sx={{ py: 10, background: '#f8f9ff' }}>
          <Container>
            <SectionTitle>রিভিউ</SectionTitle>
            <Slider {...sliderSettings} slidesToShow={Math.min(reviews.length, 3)}>
              {reviews.map((r, i) => (
                <Box key={i} sx={{ px: 1 }}>
                  <Box className="review-card">
                    <Icon icon="fa:quote-left" style={{ fontSize: 24, color: '#7b2ff7', marginBottom: 12 }} />
                    <Typography sx={{ fontSize: '0.85rem', color: '#444', lineHeight: 1.7, mb: 2, minHeight: 120,
                      display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                      {get(r, 'review')}
                    </Typography>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{
                      pt: 2, borderTop: '1px solid rgba(123,47,247,0.15)',
                    }}>
                      <Box component="img" src={config.BASE_API_URL + get(r, 'studentImage')}
                        sx={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover' }} />
                      <Box>
                        <Typography sx={{ fontWeight: 700, color: '#0c366d', fontSize: '0.9rem' }}>
                          {get(r, 'studentName')}
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', color: '#7b2ff7', fontWeight: 600 }}>
                          {get(r, 'descriptionAboutRank')}
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                </Box>
              ))}
            </Slider>
          </Container>
        </Box>




        {/* ═══════════ CTA BANNER SECTION ═══════════ */}
        <Box sx={{ py: 8, background: 'linear-gradient(135deg, #0f1729 0%, #1a2744 100%)', position: 'relative', overflow: 'hidden' }}>
          {/* Subtle pattern overlay */}
          <Box sx={{
            position: 'absolute', inset: 0, opacity: 0.04,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }} />
          <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} alignItems="stretch">
              {/* Left CTA - Call card */}
              <Box sx={{
                flex: 2, borderRadius: 4, overflow: 'hidden', position: 'relative',
                background: 'linear-gradient(135deg, #fffde4 0%, #e8f5e9 100%)',
                p: { xs: 3, md: 4 }, display: 'flex', flexDirection: 'column', justifyContent: 'center',
              }}>
                <Typography sx={{ fontWeight: 800, fontSize: { xs: '1.2rem', md: '1.5rem' }, color: '#1a3e2f', mb: 1 }}>
                  যেকোনো প্রয়োজনে কল করো এখনই
                </Typography>
                <Typography sx={{ color: '#4a6b5a', fontSize: '0.9rem', mb: 0.5 }}>
                  নিবন্ধন, কোর্স, তোমার পড়াশোনা, প্রশ্নোত্তর যেকোনো বিষয়ে জিজ্ঞাসায় কল করো
                </Typography>
                <Typography sx={{ color: '#7b2ff7', fontWeight: 700, fontSize: '0.85rem', mb: 2 }}>
                  📞 সকাল ৯ টা - রাত ১০ টা
                </Typography>
                <Button variant="contained" component="a" href="tel:01742481277"
                  startIcon={<Icon icon="mingcute:phone-fill" />}
                  sx={{
                    background: 'linear-gradient(135deg, #00897b, #26a69a)', color: '#fff',
                    fontWeight: 700, px: 4, py: 1.5, borderRadius: 3, width: 'fit-content',
                    fontSize: '1rem', textTransform: 'none', boxShadow: '0 4px 15px rgba(0,137,123,0.3)',
                    '&:hover': { background: 'linear-gradient(135deg, #00796b, #009688)' },
                  }}>
                  01742-481277
                </Button>


              </Box>

              {/* Right cards stack */}
              <Stack spacing={2} sx={{ flex: 1 }}>
                {/* YouTube card */}
                <Box sx={{
                  borderRadius: 3, p: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  background: 'linear-gradient(135deg, #ffe8e8 0%, #ffd4d4 100%)',
                  cursor: 'pointer', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-3px)' },
                }} onClick={() => window.open('https://youtube.com/@MediInn?si=36pPdyVtsTLSD3aj', '_blank')}>
                  <Box>
                    <Typography sx={{ fontWeight: 800, color: '#c62828', fontSize: '1.1rem' }}>
                      ফ্রি ভিডিও লাইব্রেরি
                    </Typography>
                    <Button size="small" sx={{
                      mt: 1, background: '#fff', color: '#c62828', fontWeight: 700,
                      borderRadius: 2, textTransform: 'none', px: 2,
                      '&:hover': { background: '#ffeaea' },
                    }}>
                      ভিডিও দেখো
                    </Button>
                  </Box>
                  <Icon icon="logos:youtube-icon" style={{ fontSize: 48 }} />
                </Box>

                {/* Facebook card */}
                <Box sx={{
                  borderRadius: 3, p: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  background: 'linear-gradient(135deg, #e3f2fd 0%, #d1e8ff 100%)',
                  cursor: 'pointer', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-3px)' },
                }} onClick={() => window.open('https://www.facebook.com/profile.php?id=100094307029795', '_blank')}>
                  <Box>
                    <Typography sx={{ fontWeight: 800, color: '#1565c0', fontSize: '1.1rem' }}>
                      Medi Inn ফেসবুক গ্রুপ
                    </Typography>
                    <Button size="small" sx={{
                      mt: 1, background: '#fff', color: '#1565c0', fontWeight: 700,
                      borderRadius: 2, textTransform: 'none', px: 2,
                      '&:hover': { background: '#e8f0fe' },
                    }}>
                      গ্রুপে যুক্ত হও
                    </Button>
                  </Box>
                  <Icon icon="logos:facebook" style={{ fontSize: 44 }} />
                </Box>
              </Stack>
            </Stack>
          </Container>
        </Box>

        {/* ═══════════ MAIN FOOTER ═══════════ */}
        <Box sx={{ py: 6, background: '#eef1f6' }}>
          <Container maxWidth="lg">
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 4, md: 6 }}>
              {/* Column 1: Brand & Social */}
              <Box sx={{ flex: 1.2 }}>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
                  <Box sx={{
                    width: 42, height: 42, borderRadius: '12px', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    background: 'linear-gradient(135deg, #7b2ff7, #00d4ff)',
                  }}>
                    <Icon icon="healthicons:doctor" style={{ fontSize: 26, color: '#fff' }} />
                  </Box>
                  <Typography sx={{ fontWeight: 900, fontSize: '1.4rem', color: '#0c366d' }}>
                    Medi Inn
                  </Typography>
                </Stack>
                <Typography sx={{ color: '#7b2ff7', fontWeight: 700, fontSize: '0.85rem', mb: 2 }}>
                  সাদা এ্যাপ্রোনের স্বপ্ন পূরণে
                </Typography>
                <Typography sx={{ color: '#666', fontSize: '0.82rem', mb: 2.5, lineHeight: 1.6, maxWidth: 260 }}>
                  মেডিকেল এ্যাডমিশনে সেরা প্রস্তুতি নিতে ডাঃ আসিফ ও K@bir Sizer এর দেশসেরা প্লাটফর্ম।
                </Typography>
                <Typography sx={{ color: '#444', fontWeight: 700, fontSize: '0.8rem', mb: 1.5 }}>
                  আমাদের সাথে কানেক্টেড থাকো
                </Typography>
                <Stack direction="row" spacing={1.5}>
                  {[
                    { icon: 'ri:facebook-fill', color: '#1877F2', bg: '#e3f2fd', link: 'https://www.facebook.com/profile.php?id=100094307029795' },
                    { icon: 'bi:youtube', color: '#FF0000', bg: '#fce4ec', link: 'https://youtube.com/@MediInn?si=36pPdyVtsTLSD3aj' },
                    { icon: 'mdi:instagram', color: '#E1306C', bg: '#fce4ec', link: '#' },
                    { icon: 'mdi:linkedin', color: '#0077B5', bg: '#e3f2fd', link: '#' },
                  ].map((s, i) => (
                    <Box key={i} component="a" href={s.link} target="_blank" rel="noopener"
                      sx={{
                        width: 40, height: 40, borderRadius: '50%', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', background: s.bg,
                        transition: 'all 0.3s', cursor: 'pointer',
                        '&:hover': { transform: 'translateY(-3px)', boxShadow: `0 4px 12px ${s.color}30` },
                      }}>
                      <Icon icon={s.icon} style={{ fontSize: 20, color: s.color }} />
                    </Box>
                  ))}
                </Stack>
              </Box>

              {/* Column 2: Links */}
              <Box sx={{ flex: 0.8 }}>
                <Typography sx={{ fontWeight: 800, color: '#0c366d', fontSize: '1rem', mb: 2 }}>
                  লিংক
                </Typography>
                <Stack spacing={1.2}>
                  {[
                    { label: 'আমাদের সম্পর্কে', href: '#' },
                    { label: 'কোর্স সমূহ', href: '#courses' },
                    { label: 'রিভিউ', href: '#' },
                    { label: 'অর্জন', href: '#' },
                    { label: 'লগইন / ড্যাশবোর্ড', href: '/login' },
                  ].map((link, i) => (
                    <Typography key={i} component="a" href={link.href}
                      sx={{
                        color: '#555', fontSize: '0.88rem', textDecoration: 'none',
                        transition: 'all 0.2s', display: 'block',
                        '&:hover': { color: '#7b2ff7', paddingLeft: '6px' },
                      }}>
                      {link.label}
                    </Typography>
                  ))}
                </Stack>
              </Box>

              {/* Column 3: Contact */}
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontWeight: 800, color: '#0c366d', fontSize: '1rem', mb: 2 }}>
                  যোগাযোগ
                </Typography>
                <Stack spacing={2}>
                  {[
                    { icon: 'mingcute:phone-fill', color: '#00897b', text: '01742-481277', href: 'tel:01742481277' },
                    { icon: 'bxl:gmail', color: '#DF3E30', text: 'drasifmedicalprivatebatch@gmail.com', href: 'mailto:drasifmedicalprivatebatch@gmail.com' },
                    { icon: 'mdi:map-marker', color: '#7b2ff7', text: 'খুলনা, বাংলাদেশ', href: 'https://maps.google.com/?q=Khulna,Bangladesh' },
                  ].map((c, i) => (
                    <Stack key={i} direction="row" spacing={1.5} alignItems="flex-start"
                      component="a" href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined}
                      rel={c.href.startsWith('http') ? 'noopener' : undefined}
                      sx={{ textDecoration: 'none', cursor: 'pointer', transition: 'all 0.2s', '&:hover': { transform: 'translateX(4px)' } }}>
                      <Box sx={{
                        width: 36, height: 36, borderRadius: '10px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', background: '#fff',
                        flexShrink: 0, boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      }}>
                        <Icon icon={c.icon} style={{ fontSize: 18, color: c.color }} />
                      </Box>
                      <Typography sx={{ color: '#555', fontSize: '0.88rem', pt: 0.5, wordBreak: 'break-word' }}>
                        {c.text}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Box>

              {/* Column 4: Company Info */}
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontWeight: 800, color: '#0c366d', fontSize: '1rem', mb: 2 }}>
                  কোম্পানির তথ্য
                </Typography>
                <Stack spacing={1.5}>
                  <Typography sx={{ color: '#555', fontSize: '0.85rem' }}>
                    প্ল্যাটফর্ম: <strong>Medi Inn</strong>
                  </Typography>
                  <Typography sx={{ color: '#555', fontSize: '0.85rem' }}>
                    প্রতিষ্ঠাতা: <strong>ডাঃ আসিফ & K@bir Sizer</strong>
                  </Typography>
                  <Typography sx={{ color: '#555', fontSize: '0.85rem' }}>
                    বিষয়: মেডিকেল এ্যাডমিশন কোচিং
                  </Typography>
                  <Typography sx={{ color: '#555', fontSize: '0.85rem' }}>
                    ধরণ: অনলাইন ও অফলাইন
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Container>
        </Box>

        {/* ═══════════ BOTTOM BAR ═══════════ */}
        <Box sx={{
          py: 2.5, background: '#e4e8ee',
          borderTop: '1px solid rgba(0,0,0,0.06)',
        }}>
          <Container maxWidth="lg">
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" spacing={1}>
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap"
                sx={{ '& > a': { color: '#555', fontSize: '0.8rem', textDecoration: 'none', '&:hover': { color: '#7b2ff7' } } }}>
                <Typography component="a" href="#">Terms & Conditions</Typography>
                <Typography sx={{ color: '#ccc' }}>|</Typography>
                <Typography component="a" href="#">Refund Policy</Typography>
                <Typography sx={{ color: '#ccc' }}>|</Typography>
                <Typography component="a" href="#">Privacy Policy</Typography>
              </Stack>
              <Typography sx={{ color: '#888', fontSize: '0.8rem' }}>
                © {new Date().getFullYear()} Medi Inn — Dr. Asif & K@bir Sizer
              </Typography>
            </Stack>
          </Container>
        </Box>
      </Box>
    </Page>
  );
}
